import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Modal,
  ListGroup,
  ListGroupItem
} from "react-bootstrap";
import { render } from "react-dom";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

class ListItem extends Component {
  constructor(props) {
    super(props);
    this.handleRemove = this.handleRemove.bind(this);
  }
  handleRemove = e => {
    let index = e.target.attributes.getNamedItem("data-key").value;
    this.props.handleRemove(index);
  };
  render() {
    const { value, sortIndex } = this.props;
    return (
      <ListGroupItem>
        {value.title}
        <span className="pull-right">
          <Button
            onClick={this.handleRemove}
            data-key={sortIndex}
            bsStyle="danger"
            bsSize="xsmall"
          >
            Delete
          </Button>
        </span>
      </ListGroupItem>

    );
  }
}


const SortableItem = SortableElement(ListItem, { withRef: true });

export default SortableItem;



// WEBPACK FOOTER //
// ./src/app/views/admin/EmailManager/multi/SortableItem.js